import * as React from 'react';
import { Props } from 'react';

import './RegistrationAuthorization.scss';
import i18next from 'i18next';

interface IsSendCodeViewProps extends Props<IsSendCodeView> {
    name: string;
    channelId: string;
    onSendCode: () => any;
    onClose: () => any;
}

export class IsSendCodeView extends React.Component<IsSendCodeViewProps> {
    render() {
        const {onSendCode, onClose, name, channelId} = this.props;
        return (
            <div className={`authorization-container ${channelId}`}>
                <div className={`authorization ${channelId}`}>
                    <div className={`auth-tab ${channelId}`}>
                        <div className={`auth-title auth-title-${channelId}`}>
                            {name}
                        </div>
                    </div>
                    <div className='auth-body'>
                        <div className='auth-body-title'>
                            {i18next.t('code_expired_repeat')}
                        </div>
                    </div>
                    <div className='auth-button-container'>
                        <div className={`auth-button ${channelId}`} onClick={() => onSendCode()} style={{width: '50%', margin: '0 10px'}}>
                            {i18next.t('yes')}
                        </div>
                        <div className={`auth-button ${channelId}`} onClick={() => onClose()} style={{width: '50%', margin: '0 10px'}}>
                            {i18next.t('no')}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/RegistrationAuthorization/IsSendCodeView.tsx